<template>
    <div class="ProfessionalOrganizationReview">
        <div class="table">
            <el-table :data="tableData" style="width: 100%">
                <el-table-column cell-class-name="custom-text-size" width="100" label="序号">
                    <template slot-scope="scope">
                        <span>{{ (page - 1) * SizePage + scope.$index + 1 }}</span>
                    </template>
                </el-table-column>
                <el-table-column cell-class-name="custom-text-size" width="100" prop="name"
                    label="机构名称"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" width="250" prop="user_group_List"
                    label="注册类型"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" width="110" prop="link_name"
                    label="联系人"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" width="120" prop="link_mobile"
                    label="联系电话"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" prop="status" label="审核结果"></el-table-column>
                <el-table-column cell-class-name="custom-text-size" label="操作">
                    <template slot-scope="scope">
                        <el-button class="" size="mini" @click="LockInfo(scope.row)" v-if="scope.row.status === '未审核'">审核</el-button>
                        <el-button class="" size="mini" @click="LockInfo(scope.row)" v-else>详情</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <div class="PageDis">
                <el-pagination background :page-sizes="[10, 20, 50]" layout="prev,pager,next,total,sizes"
                    @size-change="SizeChange" @current-change="PageChange" :total="total" :current-page="page"
                    :hide-on-single-page="false"></el-pagination>
            </div>
        </div>
        <el-dialog title="专业机构评审详情" :visible.sync="ReviewBlon" width="60%" :show-close="true">
            <div class="CommDig">
                <div class="TitleBox">
                    <span>基本信息</span>
                </div>
                <table width="100%" class="Table" v-if="reviewInfo.company">
                    <tbody>
                        <tr>
                            <td width="10%"><span class="Red">*</span>机构名称</td>
                            <td width="23%"><el-input size="small" v-model="reviewInfo.company.name"
                                    disabled></el-input></td>
                            <td width="10%"><span class="Red">*</span>机构法人</td>
                            <td width="23%"><el-input size="small" v-model="reviewInfo.company.legal_person"
                                    disabled></el-input>
                            </td>
                            <td width="10%">机构网址</td>
                            <td width="23%"><el-input size="small" v-model="reviewInfo.company.mechanism_website"
                                    disabled></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td>机构公众号</td>
                            <td><el-input size="small" v-model="reviewInfo.company.mechanism_wnumber"
                                    disabled></el-input>
                            </td>
                            <td><span class="Red">*</span>营业执照</td>
                            <td>
                                <div class="TableDis">
                                    <div class="StepCommFileImg" v-if="reviewInfo.company.legal_license">
                                        <img :src="$Global.CommImgHttp + reviewInfo.company.legal_license" alt=""
                                            @click="OpenLock(reviewInfo.company.legal_license)">
                                    </div>
                                </div>
                            </td>
                            <td><span class="Red">*</span>联系人</td>
                            <td><el-input size="small" v-model="reviewInfo.company.link_name" disabled></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>联系电话</td>
                            <td><el-input size="small" v-model="reviewInfo.company.link_mobile" disabled></el-input>
                            </td>
                            <td><span class="Red">*</span>联系邮箱</td>
                            <td><el-input size="small" v-model="reviewInfo.company.link_email" disabled></el-input>
                            </td>
                            <td><span class="Red">*</span>单位性质</td>
                            <td>
                                <el-input size="small" v-model="reviewInfo.company.institutions_text"
                                    disabled></el-input>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>业务领域</td>
                            <td>
                                <el-input size="small" v-model="reviewInfo.company.business_field_text"
                                    disabled></el-input>
                            </td>
                            <td colspan="4"></td>
                            <!-- <td><span class="Red">*</span>社会机构</td>
                            <td colspan="3"><el-input size="small" v-model="reviewInfo.company.social_institution"
                                    disabled></el-input>
                            </td> -->
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>通信地址</td>
                            <td colspan="5">
                                <div class="TableDis">
                                    <el-input size="small" v-model="reviewInfo.company.address" disabled></el-input>
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td><span class="Red">*</span>简介</td>
                            <td colspan="5"><el-input size="small" type="textarea" :rows="2"
                                    v-model="reviewInfo.company.synopsis" disabled></el-input></td>
                        </tr>
                    </tbody>
                </table>
                <div class="TitleBox">
                    <span>专业信息</span>
                </div>
                <div>
                    <div class="ZhuanYeWai" v-for="(item, index) in ZhuanYeXinXiInfo" :key="index" v-if="item.question_info">
                        <div class="ZhuanYeTheme">{{ item.question_info.name }}</div>
                        <!-- 父级问题的答案和文件 -->
                        <div class="ZhuanYeBox" v-if="item.answer || item.fileList || item.templatefileList">
                            <div class="ZhuanYeBoxInfo">
                                <div>
                                    <span v-if="item.question_info.type == 2 || item.question_info.type == 4">
                                        {{ item.question_info.name }}<span style="color: red;"> {{ item.answer }}</span>{{ item.question_info.unit }}
                                    </span>
                                    <span v-else>{{ item.question_info.name }}</span>
                                </div>
                            </div>
                            <div v-if="item.fileList && item.fileList.length > 0">
                                <div class="UploadTitle">上传文件:</div>
                                <div class="ZhuanYeBoxFile" v-for="(t, indext) in item.fileList" :key="indext">
                                    <div class="FileItem" @click="OpenLock(t)">
                                        <img :title="t.name" :src="$Global._isFileName(t.url)" alt="">
                                        <div :title="t.name" class="FileTitle">{{ t.name }}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="item.templatefileList && item.templatefileList.length > 0">
                                <div class="UploadTitle">文件:</div>
                                <div class="ZhuanYeBoxFile" v-for="(d, indexd) in item.templatefileList" :key="indexd">
                                    <div class="FileItem" @click="OpenLock(d)">
                                        <img :title="d.name" :src="$Global._isFileName(d.url)" alt="">
                                        <div :title="d.name" class="FileTitle">{{ d.name }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <!-- 子级问题 -->
                        <div class="ZhuanYeBox" v-for="(items, indexs) in item.children" :key="indexs" v-if="items.question_info">
                            <div class="ZhuanYeBoxInfo">
                                <div>
                                    <span v-if="items.question_info.type == 2 || items.question_info.type == 4">{{
                                        indexs +
                                        1 }}. {{ items.question_info.name }}<span style="color: red;"> {{ items.answer
                                            }}
                                        </span>{{
                                            items.question_info.unit
                                        }}</span>
                                    <span v-else>{{ indexs +
                                        1 }}. {{ items.question_info.name }}</span>
                                </div>
                            </div>
                            <div v-if="items.fileList && items.fileList.length > 0">
                                <div class="UploadTitle">上传文件:</div>
                                <div class="ZhuanYeBoxFile" v-for="(t, indext) in items.fileList" :key="indext">
                                    <div class="FileItem" @click="OpenLock(t)">
                                        <img :title="t.name" :src="$Global._isFileName(t.url)" alt="">
                                        <div :title="t.name" class="FileTitle">{{ t.name }}</div>
                                    </div>
                                </div>
                            </div>
                            <div v-if="items.templatefileList && items.templatefileList.length > 0">
                                <div class="UploadTitle">文件:</div>
                                <div class="ZhuanYeBoxFile" v-for="(d, indexd) in items.templatefileList" :key="indexd">
                                    <div class="FileItem" @click="OpenLock(d)">
                                        <img :title="d.name" :src="$Global._isFileName(d.url)" alt="">
                                        <div :title="d.name" class="FileTitle">{{ d.name }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="TitleBox">
                    <span>审核</span>
                </div>
                <div class="DigItem">
                    <div class="DigTit">状态</div>
                    <div>
                        <el-radio-group :disabled="status_type !== 0" v-model="SetData.status" size="small">
                            <el-radio :label=1>通过</el-radio>
                            <el-radio :label=2>不通过</el-radio>
                        </el-radio-group>
                    </div>
                </div>
                <div class="DigItem" v-if="SetData.status == 2">
                    <div class="DigTit">驳回理由</div>
                    <div>
                        <el-input size="small" type="textarea" :rows="5" placeholder="请输入"
                            v-model="SetData.reason"></el-input>
                    </div>
                </div>
                <div class="DigBtns">
                    <div class="Btn" @click="ReviewBlon = false, SetData = {}">取消</div>
                    <div v-if="status_type == 0" class="Btn Blue" @click="ReviewSuc">提交</div>
                </div>
            </div>
        </el-dialog>
    </div>
</template>
<script>
const processStatus = {
    '0': '未审核',
    '1': '已审核',
    '2': '已驳回',
}
export default {
    data() {
        return {
            tableData: [],
            total: 0,
            page: 1,
            SizePage: 10,
            ReviewBlon: false,
            SetData: {
                status: -1,
                reason: "",
            },
            reviewInfo: {},
            ZhuanYeXinXiInfo: [],
            status_type: 0,
        }
    },
    props: {
        SearchInfo: {
            type: Object, //类型
            required: false, //必要性
            default: {} //默认值
        }
    },
    mounted() {
        this.getData()
    },
    methods: {
        getData() {
            let params = {
                type: 3,
                page: this.page,
                limit: this.SizePage,
            }
            this.$post("api/user/myJudge", { ...params, ...this.SearchInfo }).then(res => {
                if (res.data.code == 1) {
                    this.total = res.data.data.total;
                    res.data.data.data.forEach(item => {
                        item.name = item.company.name;
                        item.link_name = item.company.link_name;
                        item.link_mobile = item.company.link_mobile;
                        item.status = processStatus[item.status];
                        var user_group_List = [];
                        item.user_group.forEach(items => {
                            user_group_List.push(items.name);
                        })
                        item.user_group_List = user_group_List.join(',');
                    });
                    this.tableData = res.data.data.data;
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        LockInfo(row) {
            this.$post("api/user/myJudgeDetails", {
                type: 3,
                ids: row.id,
            }).then(res => {
                if (res.data.code == 1) {
                    this.ReviewBlon = !this.ReviewBlon;
                    this.reviewInfo = res.data.data;
                    this.SetData.reason = this.reviewInfo.reason;
                    this.SetData.status = this.reviewInfo.status;
                    this.status_type = this.reviewInfo.status;
                    this.ZhuanYeXinXiInit();
                } else {
                    this.$message.error(res.data.msg)
                }
            })
        },
        ZhuanYeXinXiInit() {
            var { question } = this.reviewInfo;
            question.forEach(item => {
                if (item.file && item.file !== '[]') {
                    try {
                        item.fileList = JSON.parse(item.file);
                    } catch (e) {
                        console.warn('解析file字段失败:', item.file);
                        item.fileList = [];
                    }
                }
                if (item.templatefile && item.templatefile !== '[]') {
                    try {
                        item.templatefileList = JSON.parse(item.templatefile);
                    } catch (e) {
                        console.warn('解析templatefile字段失败:', item.templatefile);
                        item.templatefileList = [];
                    }
                }
                item.children.forEach(items => {
                    if (items.file && items.file !== '[]') {
                        try {
                            items.fileList = JSON.parse(items.file);
                        } catch (e) {
                            console.warn('解析子级file字段失败:', items.file);
                            items.fileList = [];
                        }
                    }
                    if (items.templatefile && items.templatefile !== '[]') {
                        try {
                            items.templatefileList = JSON.parse(items.templatefile);
                        } catch (e) {
                            console.warn('解析子级templatefile字段失败:', items.templatefile);
                            items.templatefileList = [];
                        }
                    }
                })
            })
            this.ZhuanYeXinXiInfo = question;
        },
        OpenLock(res) {
            this.$Global.previewFile(res)
        },
        ReviewSuc() {
            if (!this.SetData.status) {
                this.$message.error("请选择审核状态!");
                return
            }
            if (this.SetData.status == 2 && !this.SetData.reason) {
                this.$message.error("请输入驳回理由!");
                return
            }
            this.$confirm("确认提交审核结果?", "提示", {
                confirmButtonText: "确定",
                cancelButtonText: "取消",
                type: "warning"
            }).then(() => {
                var params = {
                    type: 3,
                    ids: this.reviewInfo.id,
                    status: this.SetData.status,
                }
                if (this.SetData.status == 2) {
                    params.reason = this.SetData.reason;
                }
                this.$post("api/user/examine", params).then(res => {
                    if (res.data.code == 1) {
                        this.$message.success(res.data.msg);
                        this.getData();
                        this.ReviewBlon = false;
                        this.SetData = {
                            status: "",
                            reason: "",
                        };
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            }).catch(() => {
                this.$message.info("已取消提交");
            });
        },
        SizeChange(val) {
            this.SizePage = val;
            this.getData();
        },
        PageChange(val) {
            this.page = val;
            this.getData();
        },
    }
}
</script>
<style scoped>
.PageDis {
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 20px;
}

.DigBtns {
    display: flex;
    align-items: center;
    justify-content: center;
}

.DigBtns .Btn {
    background-color: #f6faff;
    border-radius: 10px;
    border: solid 1px #d6e5ff;
    font-size: 16px;
    color: #2354f4;
    padding: 10px 40px;
    cursor: pointer;
}

.DigBtns .Btn:hover {
    box-shadow: 0 0 10px #b6d0ed;
}

.DigBtns .Btn.Blue {
    background-color: #027cfb;
    color: #fff;
    margin-left: 20px;
}

.CommDig {
    max-height: 600px;
    overflow: auto;
}

.Table {
    width: 99%;
    margin: 10px auto;
    border-radius: 5px;
    border-collapse: collapse;
}

.Table td {
    border: 1px solid #e4eaec;
    padding: 10px;
    font-weight: 400;
    font-size: 16px;
    color: #666;
}

.Table .State {
    padding-right: 10px;
}

.Table .Th {
    color: #000000;
    font-size: 16px;
    padding: 10px;
    font-weight: 700;
}

.Table td .Red {
    color: #d51938;
    font-weight: 700;
    vertical-align: middle;
    /* margin-right: 10px; */
}

.Table .TableDis {
    display: flex;
    align-items: center;
}

.WidMax {
    width: 100%;
}

.TitleBox {
    width: 100%;
    height: 40px;
    background-color: #0385EB;
    line-height: 42px;
    margin-top: 10px;
    padding-left: 15px;
    font-size: 18px;
    font-weight: 600;
    text-align: center;
    color: #ffffff;
    box-sizing: border-box;
}

.ZhuanYeWai {
    margin-top: 15px;
}

.ZhuanYeWai .ZhuanYeTheme {
    font-size: 16px;
    font-weight: 600;
    margin: 10px 0;
}

.ZhuanYeBox {
    font-size: 16px;
    background-color: #F5F5F5;
    padding: 20px;
    margin-bottom: 10px;
}

.ZhuanYeBox1 {
    padding: 10px;
}

.ZhuanYeBox .UploadTitle {
    font-size: 16px;
}

/* .ZhuanYeBox .ZhuanYeBoxInfo {
    margin-top: 20px;
} */

.ZhuanYeBoxFile {
    display: flex;
    flex-wrap: wrap;
    width: 100%;
    padding: 10px 10px 0 10px;
    border: 1px #0385EB solid;
    box-sizing: border-box;
}

.ZhuanYeBoxFile .FileItem {
    cursor: pointer;
    width: 90px;
    font-size: 14px;
    padding: 0 10px 10px 0;
}

.ZhuanYeBoxFile .FileItem .FileTitle {
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    line-height: 15px;
    width: 90px;
    margin-top: 2px;
}

.ZhuanYeBoxFile .FileItem img {
    width: 90px;
    height: 90px;
}

.AnLIBaoGaoBox {
    margin-top: 20px;
}

.ZhuanYeItem {
    width: 500px;
}

.ZhuanYeItemRadio {
    margin-top: 10px;
}

.ZhuanYeItemRadio .radio-label {
    font-weight: 600;
    font-size: 16px;
}

.ZhuanYeItemTit {
    text-align: center;
    font-weight: 400;
    font-size: 16px;
    color: #666666;
    padding: 10px 0;
}

.ZhuanYeItemDis {
    display: flex;
    align-items: center;
    margin-bottom: 20px;
}

.ZhuanYeItemCont {
    width: 75%;
    margin: 10px 0 0 10px;
}

.ZhuanYeItemFuTit {
    font-weight: 400;
    font-size: 16px;
    color: #666666;
    width: 30%;
}

.ZhuanYeItemVal {
    margin-left: 20px;
    flex: 1;
}

.DigItem {
    display: flex;
    margin: 20px 0;
}

.DigItem .DigTit {
    font-size: 16px;
    color: #000000;
    width: 80px;
}

.DigItem input,
.DigItem textarea {
    border-radius: 10px;
    border: solid 1px #e1e1e1;
    padding: 15px;
    flex: 1;
}

.DigItem .DigSelect {
    width: 300px;
    margin: 0;
}

.SupervisorBox {
    padding-left: 20px;
}

.SpanColorRed {
    color: red;
}

.StepCommFileImg {
    border: 1px solid #ddd;
    padding: 2px;
    cursor: pointer;
    margin-left: 5px;
}

.StepCommFileImg img {
    width: 50px;
    height: 50px;
}
</style>
<style>
.ProfessionalOrganizationReview .el-dialog__body {
    padding: 0 20px 20px 20px;
}
</style>